const NOCS_STATUS = {
  ALL:"ALL",
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  REVISIONREQ: "REVISIONREQUIRED",
};
export default NOCS_STATUS;
